import React from "react";

type TableSearchProps = {
  /** Raw (un-debounced) input value. */
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  /** Accessible name for the field; defaults to the placeholder. */
  ariaLabel?: string;
  /** Extra filter controls rendered inline, between the input and Clear. */
  children?: React.ReactNode;
  /** Overrides the default "show Clear when the input is non-empty" rule. */
  showClear?: boolean;
  onClear: () => void;
};

/**
 * Search bar above an admin dataset table. Presentational only — the caller
 * owns the debounce (see `useDebouncedSearch`) and the query it feeds.
 */
export const TableSearch = ({
  value,
  onChange,
  placeholder,
  ariaLabel,
  children,
  showClear,
  onClear,
}: TableSearchProps) => (
  <div className="mb-3 flex flex-wrap items-center gap-2">
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={ariaLabel ?? placeholder}
      className="w-full max-w-sm rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 px-3 py-2 text-body text-blue_grey placeholder-gray-400 focus:border-penn-500 focus:ring-1 focus:ring-penn-500 outline-none"
    />
    {children}
    {(showClear ?? value !== "") && (
      <button
        type="button"
        onClick={onClear}
        className="rounded-lg border border-gray-200 dark:border-gray-700 px-3 py-2 text-button text-blue_grey2 hover:bg-gray-50 dark:hover:bg-gray-800"
      >
        Clear
      </button>
    )}
  </div>
);
